import styled, { css } from 'styled-components';
import { THEME_COLORS } from '../styles/theme';
import { FontFamilyRegular, FontSize16, FontFamilyBold } from './fonts';

export const BaseText = css`
    ${FontSize16};
    ${FontFamilyRegular};
    font-weight: normal;
    color: ${props => props.theme.color[props.color] || props.theme.color[THEME_COLORS.darkBlue]};
`;

export const TextAlignCenter = css`
    text-align: center;
`;

export const Text = styled.span`
    ${BaseText};
`;

export const TextBlock = styled.p`
    margin: 0;
    ${BaseText};
`;

export const TextBold = styled.span`
    ${BaseText};
    ${FontFamilyBold};
`;

export const TextBoldBlock = styled(TextBlock)`
    ${FontFamilyBold};
`;